import type { StyleSpecification } from "maplibre-gl";

export const WEATHER_LAYER_ANCHOR_ID = "maplibre-weather-layer-anchor";
export const OVERLAY_LAYER_ANCHOR_ID = "maplibre-overlay-layer-anchor";

/** Minimal style; authenticated Azure raster layers are mounted by React. */
export const EMPTY_MAP_STYLE: StyleSpecification = {
  version: 8,
  sources: {},
  layers: [
    {
      id: "maplibre-background",
      type: "background",
      paint: { "background-color": "#eef2f5" },
    },
    {
      id: WEATHER_LAYER_ANCHOR_ID,
      type: "background",
      paint: { "background-color": "rgba(0, 0, 0, 0)" },
    },
    {
      id: OVERLAY_LAYER_ANCHOR_ID,
      type: "background",
      paint: { "background-color": "rgba(0, 0, 0, 0)" },
    },
  ],
};
